import { BaseSerializer } from './base.serializer'
import { CenterProgram } from '../models/center-program.model'
import { AccessConditionSerializer } from 'serializers/access-condition.serializer'
import { ProgramSerializer } from 'serializers/program.serializer'
import { CenterRepeatExamSettingSerializer } from './center-program-retake-exam-setting.serializer'


export class CenterProgramSerializer extends BaseSerializer<CenterProgram> {
  static SERIALIZABLE_ATTRIBUTES = [
    'state', 'id', 'program_id', 'center_id', 'accessConditions', 'smsAfterFinish',
    'needInterview', 'interviewSlotsMandatory', 'needBriefing', 'briefingSlotsMandatory', 'programId',
    'retakeExamSettings', 'interviewId', 'hideResults', 'exportToCourses',
    'smsAfterFinishRules', 'webRetakeExamSettings', 'position','interviewRegistrationSmsId', "_destroy",
    'interviewCancellationSmsId', 'interviewReminderSmsId', 'interviewReminderSmsTime', 'briefingIds', 'driverRating'
  ]
  static SERIALIZERS = {
    accessConditions: AccessConditionSerializer,
    program: ProgramSerializer,
    retakeExamSettings: CenterRepeatExamSettingSerializer,
    webRetakeExamSettings: CenterRepeatExamSettingSerializer,
  }
  static SERIALIZE_RENAME_KEYS = {
    accessConditions: 'accessConditionsAttributes',
    retakeExamSettings: 'retakeExamSettingsAttributes',
    webRetakeExamSettings: 'webRetakeExamSettingsAttributes'
  }

  static DESERIALIZERS = {
    accessConditions: AccessConditionSerializer,
    program: ProgramSerializer,
    retakeExamSettings: CenterRepeatExamSettingSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): CenterProgram {
    return new CenterProgram(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/center-program.serializer.ts